import { Logger } from '@vue-storefront/core';
import { CATEGORY_TREE, CategoryTree } from '~/constants/categoryTree';
import { getPageLinkForSlug } from '~/helpers/routes/getPageInformation';
import { getCategoryPath } from '~/helpers/category/getCategoryPath';
import { hasNativeRouteRedirection } from '~/helpers/navigation/nativeRoutingRedirection';
import { NATIVE_ROUTE } from '~/constants/routes';
import { CountryCodeValue } from '~/types/localization/localizationHelperTypes';

export const buildCategoryPageUrl = ({
  category,
  countryCode,
  categoryTree = CATEGORY_TREE.DEFAULT,
}: {
  category: string;
  countryCode: CountryCodeValue;
  categoryTree?: CategoryTree;
}): string => {
  if (!category) {
    Logger.info('undefined category detected');
    return '';
  }
  if (category === '/') {
    return category;
  }
  const categoryRouteIndicator = hasNativeRouteRedirection(countryCode) ? `${NATIVE_ROUTE.CATEGORY}/` : '';
  const cleanedCategory = category.replace(/\//g, '');
  const categoryRoute = `${categoryRouteIndicator}${cleanedCategory}`;
  const categoryPath = getCategoryPath(categoryRoute, categoryTree);
  return getPageLinkForSlug(categoryPath);
};
